
import "./medical.css";

import Header from "../../../components/Header";    
import Footer from "../../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";

/* banco de dados */
import { db, auth } from "../../../services/firebaseConnection";
import { collection, addDoc, doc, updateDoc, query, where, getDoc, getDocs, setDoc, limit, runTransaction, serverTimestamp } from "firebase/firestore";

import { useForm } from "react-hook-form";

/* navegação */
import { useLocation, useNavigate } from "react-router-dom";

/* validação de campos */
import { masktelefone, maskcep, maskdata } from "../../../services/masks/masks.ts";

/* funções auxiliares */
import { registerLog, showError, clearError, formError, isValidDate, dateToTimestamp, formatTimestamp, wait, firstName, expiryDate, db_basic } from "../../../services/functions/functions.ts";

/* imagens */
import icon_success from "../../../assets/sucesso.png";
import seta_prev_on from "../../../assets/seta_prev_on.png";
import seta_next_on from "../../../assets/seta_next_on.png";
import seta_prev_off from "../../../assets/seta_prev_off.png";
import seta_next_off from "../../../assets/seta_next_off.png";
import expand_yes from "../../../assets/expand_yes.png";

/* uuis automáticos*/
import { v4 as uuidv4 } from "uuid";

/* envio de email */
import { templateConfigureAgent } from "../../../services/emails/templates.js";


export default function Medical() {

    /*
    1 - dados da clínica
    2 - médico, especialidades, consulta e convênios
    3 - exames
    4 - agenda
    5 - finalizar
    */

    const location = useLocation();
    const [step, setStep] = useState(() => { if (typeof location.state?.step === "number") { return location.state.step; } return 0; });

    const [basic, setBasic] = useState(null);
    const [loadBasic, setLoadBasic] = useState(true);

    const [error, setError] = useState("0");
    const [telefone, setTelefone] = useState("");
    const [idDoc, setIdDoc] = useState("0");

    const [load, setLoad] = useState(true);

    const [indisponivel, setIndisponivel] = useState(false);

    /* controle de exames */
    const [exames, setExames] = useState([]);
    const [examesOpen, setExamesOpen] = useState([]);
    const [exameEditando, setExameEditando] = useState(null);
    const [examesErrors, setExamesErrors] = useState({});
    const [exameDraft, setExameDraft] = useState(null);

    /* controle de convênios */
    const [convenio, setConvenio] = useState(false);
    const [selectedConvenios, setSelectedConvenios] = useState([]);
    const [convenios, setConvenios] = useState(["Amil", "Bradesco Saúde", "SulAmérica", "Unimed", "Hapvida", "Omint", "NotreDame", "Care Plus", "São Cristóvão", "Porto Seguro", "Golden Cross", "Assim Saúde", "Caixa Seguros", "Prevent Senior", "Trasmontano", "Allianz",  "Santa Helena"]);
    const [novoConvenio, setNovoConvenio] = useState("");
    const [adicionandoConvenio, setAdicionandoConvenio] = useState(false);
    const [showModalConvenio, setShowModalConvenio] = useState(false);

    /* controle do calendário */
    const [showCalendar, setShowCalendar] = useState(false);
    const [dsp, setDsp] = useState(0);
    const [tempoAtendimento, setTempoAtendimento] = useState(null);
    const [calendario, setCalendario] = useState([]);
    const [mondayBase, setMondayBase] = useState(getWeekRange().monday);
    const [mondayStart, setMondayStart] = useState(null);
    const [mondayEnd, setMondayEnd] = useState(null);
    const [replicando, setReplicando] = useState(false);
    const [inputTempoAtendimento, setInputTempoAtendimento] = useState(false);
    const [buttonTempoAtendimento, setButtonTempoAtendimento] = useState(false);


    /* referências para tratativa de erros */
    //tela 1 - clinica
    const refDescription = useRef(null);
    const refLabelDescription = useRef(null);
    const refErrorDescription = useRef(null);

    const refCep = useRef(null);
    const refLabelCep = useRef(null);
    const refErrorCep = useRef(null);

    const refLogradouro = useRef(null);
    const refLabelLogradouro = useRef(null);
    const refErrorLogradouro = useRef(null);

    const refNumero = useRef(null);
    const refLabelNumero = useRef(null);

    const refMunicipio = useRef(null);
    const refLabelMunicipio = useRef(null);
    const refErrorMunicipio = useRef(null);

    const refUf = useRef(null);
    const refLabelUf = useRef(null);

    const refSite = useRef(null);
    const refLabelSite = useRef(null);
    const refErrorSite = useRef(null);

    const refInsta = useRef(null);
    const refLabelInsta = useRef(null);

    const refTelefone = useRef(null);
    const refLabelTelefone = useRef(null);
    const refErrorTelefone = useRef(null);

    //tela 2 - médico
    const refMedico = useRef(null);
    const refLabelMedico = useRef(null);
    const refErrorMedico = useRef(null);

    const refEspecialidade = useRef(null);
    const refLabelEspecialidade = useRef(null);
    const refErrorEspecialidade = useRef(null);

    const refValor = useRef(null);
    const refLabelValor = useRef(null);
    const refErrorValor = useRef(null);

    const refConvenio = useRef(null);
    const refErrorConvenio = useRef(null);

    const refNumeroConsultas = useRef(null);
    const refLabelNumeroConsultas = useRef(null);
    const refErrorNumeroConsultas = useRef(null);

    //tela 3 - exames
    const refExame = useRef(null);
    const refLabelExame = useRef(null);
    const refErrorExame = useRef(null);

    const refValorExame = useRef(null);
    const refLabelValorExame = useRef(null);

    //tela 4 - calendário
    const refTempoAtendimento = useRef(null);
    const refLabelTempoAtendimento = useRef(null);
    const refErrorTempoAtendimento = useRef(null);

    const refButtonReplicateAll = useRef(null);

    const refCalendario = useRef(null);

    const refButtonConcluir = useRef(null);

    const refCheckBox = useRef(null);
    const refErrorTerms = useRef(null);

    const refError = useRef(null);
    /* --- */

    const { handleSubmit, register, setValue, getValues, watch } = useForm();

    const navigate = useNavigate();

    const [isPending, startTransition] = useTransition();

    const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    useEffect(() => { window.scrollTo(0, 0); }, []);


    useEffect(() => {

        const loadBasic = async () => {

            const uid = auth.currentUser.uid;
            const bbd = await db_basic(uid);
            setBasic(bbd);

            //carrega informações
            try {

                if(bbd.agent.status === 1) {
                
                    setValue("empresa", bbd.client.empresa);
                    setValue("numero_consultas", 0);
                    setValue("tempo_atendimento", 60);
                }

                if(bbd.agent.status === 4) {

                    const medicaldb = collection(db, "medical");
                    const medicalquery = query(medicaldb, where("id_agent", "==", bbd.agent.id), limit(1));
                    
                    const medicaldoc = await getDocs(medicalquery);

                    setIdDoc(medicaldoc.docs[0].id);

                    // tela 1
                    setValue("empresa", bbd.client.empresa);
                    setValue("description", medicaldoc.docs[0].data().descricao);
                    setValue("cep", medicaldoc.docs[0].data().cep);
                    setValue("logradouro", medicaldoc.docs[0].data().logradouro);
                    setValue("numero", medicaldoc.docs[0].data().numero);
                    setValue("bairro", medicaldoc.docs[0].data().bairro);
                    setValue("complemento", medicaldoc.docs[0].data().complemento);
                    setValue("municipio", medicaldoc.docs[0].data().municipio);
                    setValue("uf", medicaldoc.docs[0].data().uf);
                    setValue("site", medicaldoc.docs[0].data().site);
                    setValue("instagram", medicaldoc.docs[0].data().instagram);
                    setValue("telefone_humano", medicaldoc.docs[0].data().telefone_humano);

                    // tela 2
                    setValue("medico", medicaldoc.docs[0].data().medico);
                    setValue("crm", medicaldoc.docs[0].data().crm);
                    setValue("especialidade", medicaldoc.docs[0].data().especialidade);
                    setValue("valor", Number(medicaldoc.docs[0].data().valor).toFixed(2, 0));
                    setConvenio(medicaldoc.docs[0].data().aceita_convenio);
                    setValue("numero_consultas", medicaldoc.docs[0].data().limite_consulta_convenio);
                    
                    setSelectedConvenios(medicaldoc.docs[0].data().convenios || []);

                    // tela 3
                    setExames(medicaldoc.docs[0].data().exames || []);
                    
                    // tela 4
                    const diasRef = collection(db, "calendar", bbd.agent.id, "dias");
                    const diasSnap = await getDocs(diasRef);

                    let interval = 60;

                    if (!diasSnap.empty) {

                        const firstDoc = diasSnap.docs[0];
                        interval = firstDoc.data().interval ?? 60;

                        const dias = {};

                        diasSnap.forEach(doc => {
                            dias[doc.id] = doc.data();
                        });

                        setValue("tempo_atendimento", interval);
                        create_calendar();

                        setCalendario(dias);
                        setShowCalendar(true);

                        setInputTempoAtendimento(true);
                        setButtonTempoAtendimento(true);
                        
                    }
                    
                }

            }
            catch(erro) {
                console.log(erro);
            }

            setLoadBasic(false);
        };

        loadBasic();

    }, []);


    function getWeekRange(date = new Date()) {
    
        const day = date.getDay(); // 0 = domingo, 1 = segunda ...

        const monday = new Date(date);
        monday.setDate(date.getDate() - ((day + 6) % 7));

        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);

        return {monday, sunday};
    }

    const handleChange = (event) => { 
        
        const nv = event.target.value === "true"
        setConvenio(nv);

        if(nv) {

            refConvenio.current.style.backgroundColor = "var(--BAS_2)";
            refConvenio.current.disabled = false;
            refNumeroConsultas.current.disabled = false;

        } else {

            refConvenio.current.style.backgroundColor = "rgb(240, 240, 240)";
            refConvenio.current.disabled = true;
            refNumeroConsultas.current.disabled = true;
            setValue("numero_consultas", 0);
            setSelectedConvenios([]);

        }

    };


    const handleConvenioToggle = (nome) => {setSelectedConvenios((prev) => {const novo = prev.includes(nome) ? prev.filter((item) => item !== nome) : [...prev, nome];
        
        if(novo.length > 0) {
            refErrorConvenio.current.innerHTML = "";
            refErrorConvenio.current.style.height = "0rem";
        }
        
        return novo;
        });
    };
    



    function dateToYYYYMMDD(date) {
        return Number(
            `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, "0")}${String(date.getDate()).padStart(2, "0")}`
        );
    }

    function addDays(baseDate, days) {
        const d = new Date(baseDate);
        d.setDate(d.getDate() + days);
        return d;
    }

    
    function medical_step1(e) {

        e.preventDefault();

        let ds = getValues("description");
        if(ds.length < 10) {
            showError(refDescription, refLabelDescription, refErrorDescription, "Insira alguma descrição para que seu agente atue melhor", setError, "description");
            return;
        }

        let cp = getValues("cep");
        if(cp.length < 9) {
            showError(refCep, refLabelCep, refErrorCep, "Insira um CEP com oito caracteres", setError, "cep");
            return;
        }

        let lg = getValues("logradouro");
        if(lg.length < 5) {
            showError(refLogradouro, refLabelLogradouro, refErrorLogradouro, "Insira o logradouro do endereço", setError, "logradouro");
            return;
        }

        let nu = getValues("numero");
        if(nu.length === 0) {
            showError(refNumero, refLabelNumero, refErrorLogradouro, "Insira o número do logradouro do endereço", setError, "numero");
            return;
        }

        let mu = getValues("municipio");
        if(mu.length < 3) {
            showError(refMunicipio, refLabelMunicipio, refErrorMunicipio, "Insira o nome do Município do endereço", setError, "municipio");
            return;
        }

        let uf = getValues("uf");
        if(uf.length < 2) {
            showError(refUf, refLabelUf, refErrorMunicipio, "Insira a sigla da UF do endereço", setError, "uf");
            return;
        }

        let st = getValues("site");
        if(st.length > 0) {
            const rsite = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/i;
            if(!rsite.test(st)) {
                showError(refSite, refLabelSite, refErrorSite, "Insira uma URL de web site válida", setError, "site");
                return;
            }
        }

        let ig = getValues("instagram");
        if(ig.length > 0 && ig === "@") {
            showError(refInsta, refLabelInsta, refErrorSite, "Esse endereço de Instagram não é válido", setError, "instagram");
            return;
        }

        let tl = getValues("telefone_humano");
        if(tl.length < 15) {
            showError(refTelefone, refLabelTelefone, refErrorTelefone, "Número de telefone incorreto, insira DDD + telefone", setError, "telefone_humano");
            return;
        }

        registerLog(basic.client.id, "/configure_agent/step1/id=" + basic.agent.id);

        setStep(1);
        window.scrollTo(0, 0);

    }


    function medical_step2(e) {

        e.preventDefault();

        let md = getValues("medico");
        const v_nome = (nome) => { let validade = /\b[A-Za-zÀ-ú][A-Za-zÀ-ú]+,?\s[A-Za-zÀ-ú][A-Za-zÀ-ú]{2,19}\b/gi; return validade.test(nome); }
        if(!v_nome(md)) {
            showError(refMedico, refLabelMedico, refErrorMedico, "Insira o nome do médico completo", setError, "medico");
            return;
        }

        let ep = getValues("especialidade");
        if(ep.length < 10) {
            showError(refEspecialidade, refLabelEspecialidade, refErrorEspecialidade, "Insira alguma especialidade ou fato relevante para que seu agente atue melhor", setError, "especialidade");
            return;
        }

        let vl = getValues("valor").replace(",", ".");
        if(vl.length === 0 || isNaN(Number(vl))) {
            showError(refValor, refLabelValor, refErrorValor, "Insira um valor válido em reais para sua consulta", setError, "valor");
            return;
        }

        if(convenio) {

            if(selectedConvenios.length === 0) {
                refErrorConvenio.current.innerHTML = "Selecione ao menos um convênio para prosseguir";
                refErrorConvenio.current.style.height = "1.5rem";
                return;
            }

            let nc = getValues("numero_consultas");
            if(nc.length === 0) {
                showError(refNumeroConsultas, refLabelNumeroConsultas, refErrorNumeroConsultas, "É necessário inserir um valor na quantidade de consultas conveniadas", setError, "numero_consultas");
                return;
            }

        }
        
        registerLog(basic.client.id, "/configure_agent/step2/id=" + basic.agent.id);

        setStep(2);
        window.scrollTo(0, 0);

    }


    function medical_step3() {

        registerLog(basic.client.id, "/configure_agent/step3/id=" + basic.agent.id);
        setStep(3);
        window.scrollTo(0, 0);

    }


    async function configure_agent(data) {

        formError(refError, "", false);

        if(!showCalendar) {
            formError(refError, "Você precisa criar um calendário e configurá-lo antes de concluir.", true);
            return;
        }

        if(dsp === 0) {
            formError(refError, "Você precisa configurar sua agenda selecionando dias-horários para concluir.", true);
            return;
        }

        if(basic.agent.status !== 4 && !refCheckBox.current.checked) {
            formError(refErrorTerms, "Para concluir você precisa aceitar nossos termos de uso.", true);
            return;
        }

        startTransition( async() => {

        try {

            let uid = basic.client.id;
            let aid = basic.agent.id;
            let apl = basic.agent.plano;
            let ast = basic.agent.status;
            
            refButtonConcluir.current.innerText = "AGUARDE ... registrando dados";
            
            //registra os dados
            let dt_atual = new Date();

            if(ast === 4) {
                
                const medicalRef = doc(db, "medical", idDoc);

                await runTransaction(db, async (transaction) => {

                    const medicalSnap = await transaction.get(medicalRef);

                    const medicalAtual = medicalSnap.data();
                    const agora = new Date();

                    //1. salva histórico
                    const histRef = doc(collection(db, "medical_hist"));

                    transaction.set(histRef, {
                        ...medicalAtual,
                        data_inicio_vigencia: medicalAtual.data_atualizacao,
                        data_fim_vigencia: agora,
                        archived_at: serverTimestamp()
                    });

                    //2. atualiza documento principal
                    transaction.update(medicalRef, {
                        data_atualizacao: agora,
                        empresa: data.empresa,
                        descricao: data.description,
                        cep: data.cep,
                        logradouro: data.logradouro,
                        numero: data.numero,
                        complemento: data.complemento,
                        bairro: data.bairro,
                        municipio: data.municipio,
                        uf: data.uf,
                        site: data.site,
                        instagram: data.instagram,
                        telefone_humano: data.telefone_humano,
                        medico: data.medico,
                        crm: data.crm,
                        especialidade: data.especialidade,
                        valor: Number(data.valor.replace(",", ".")),
                        aceita_convenio: convenio,
                        convenios: selectedConvenios,
                        limite_consulta_convenio: Number(data.numero_consultas),
                        exames: exames
                    });

                });

            } else {

                await addDoc(collection(db, "medical"), 
                { 
                    id_client: uid,
                    id_agent: aid,
                    codigo_plano: apl,
                    data_criacao: dt_atual,
                    data_atualizacao: dt_atual,
                    data_encerramento: null,
                    empresa: data.empresa,
                    descricao: data.description,
                    cep: data.cep,
                    logradouro: data.logradouro,
                    numero: data.numero,
                    complemento: data.complemento,
                    bairro: data.bairro,
                    municipio: data.municipio,
                    uf: data.uf,
                    site: data.site,
                    instagram: data.instagram,
                    telefone_humano: data.telefone_humano,
                    medico: data.medico,
                    crm: data.crm,
                    especialidade: data.especialidade,
                    valor: Number(data.valor.replace(",", ".")),
                    aceita_convenio: convenio,
                    convenios: selectedConvenios,
                    limite_consulta_convenio: Number(data.numero_consultas),
                    exames: exames
                })

            }

            await wait(500);

            let tel = "";
            let idgpt = "";
            
            if(ast === 4) {

                //pegar o idgpt
                const usesdb = collection(db, "uses");
                const usesquery = query(usesdb, where("id_agent", "==", aid), where("data_termino_vigencia", "==", expiryDate()), limit(1));

                const usesdoc = await getDocs(usesquery);

                let id_tel = usesdoc.docs[0].data().id_telephone;

                const telefoneref = doc(db, "telephones", id_tel);
                const telefonedoc = await getDoc(telefoneref); 

                idgpt = telefonedoc.data().id_gptmaker;
                tel = telefonedoc.data().telefone;

                setTelefone(tel);

                await wait(500);

                refButtonConcluir.current.innerText = "AGUARDE ... alterando agenda";

                altera_agenda(aid, calendario);

            } else {
            
                refButtonConcluir.current.innerText = "AGUARDE ... verificando disponibilidade";

                //verifica qual linha está disponível
                const telephonedb = collection(db, "telephones");
                const telephonequery = query(telephonedb, where("status", "==", 1), limit(1));

                const telephonedoc = await getDocs(telephonequery);

                if(telephonedoc.size === 0) {
                
                    //atualiza o agente para status 2 = linha não disponível
                    const aid = basic.agent.id;
                    const agentRef = doc(db, "agent", aid);

                    await runTransaction(db, async (transaction) => {

                        const agentSnap = await transaction.get(agentRef);

                        const agentAtual = agentSnap.data();
                        const agora = new Date();

                        //1. salva histórico
                        const histRef = doc(collection(db, "agent_hist"));

                        transaction.set(histRef, {
                            ...agentAtual,
                            id_agent: aid,
                            data_inicio_vigencia: agentAtual.data_atualizacao,
                            data_fim_vigencia: agora,
                            archived_at: serverTimestamp()
                        });

                        //2. atualiza documento principal
                        transaction.update(agentRef, {
                            status: 2,
                            data_atualizacao: agora
                        });

                    });

                    // direciona para a tela final
                    setIndisponivel(true);
                    registerLog(basic.client.id, "/configure_agent/unavailable/id=" + basic.agent.id);
                    setStep(4);
                    window.scrollTo(0, 0);

                    return;

                } else {

                    let idtel = telephonedoc.docs[0].id;
                    tel = telephonedoc.docs[0].data().telefone;
                    idgpt = telephonedoc.docs[0].data().id_gptmaker;

                    await wait(500);
                    refButtonConcluir.current.innerText = "AGUARDE ... alocando linha";

                    const mk_ln = await make_line(idtel);

                    if(mk_ln.error) {

                        //atualiza a tela e informa ao cliente
                        alert(mk_ln.description);
                        return;

                    }

                    setTelefone(tel);

                    await wait(500);

                    const up_ag = await update_agent(idtel, tel);

                    if(up_ag.error) {

                        //atualiza a tela e informa ao cliente
                        alert(up_ag.description);
                        return;

                    }

                    await wait(500);

                    refButtonConcluir.current.innerText = "AGUARDE ... criando agenda";

                    cria_agenda(aid, calendario);

                }

            }
            
            await wait(500);
            
            refButtonConcluir.current.innerText = "AGUARDE ... configurando agente";
                
            const cr_ag = await create_agentgpt(idgpt);
            
            if(cr_ag.error) {

                //atualiza a tela e informa ao cliente
                alert(cr_ag.description);
                return;

            };
            
            await wait(500);
            
            const tr_ag = await add_treinamentos(idgpt);

            if(tr_ag.error) {

                //atualiza a tela e informa ao cliente
                alert(tr_ag.description);
                return;

            };

            await wait(500);
            
            if(ast !== 4) {
            
                const it_ag = await add_intencoes(idgpt);

                if(it_ag.error) {

                    //atualiza a tela e informa ao cliente
                    alert(it_ag.description);
                    return;

                }

                await wait(500);
                
                //envia email ao cliente
                let pnm = firstName(basic.client.responsavel);
                let agn = basic.agent.nome;
                let eml = basic.client.email;

                const resEmailConfigAgent = await fetch("https://google-services-712108985873.southamerica-east1.run.app/send-email", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        to: eml,
                        subject: "Agente Criado e Configurado",
                        html: templateConfigureAgent({nome: pnm, agente: agn, telefone: tel}),
                    }),
                });

                const dataEmailConfigAgent = await resEmailConfigAgent.json();
                if(dataEmailConfigAgent.status !== "ok") {
                    alert("envio email: " + dataEmailConfigAgent.message);
                    return;
                }

                await wait(500);

            }

            registerLog(basic.client.id, "/configure_agent/success/id=" + basic.agent.id);
            setStep(4);
            window.scrollTo(0, 0);
            
        } 
        catch(erro) {
            formError(refError, "Main: " + erro, true);
        }
        finally {
            refButtonConcluir.current.innerText = basic.agent.status === 4 ? "ALTERAR" : "CONCLUIR";
        }
        })
        
    }


    async function add_treinamentos(id_agent_gptmaker) {

        try {

            //treinamento: exclui todos os treinamentos

            const resGptMakerAgenda0 = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/treinamento/empty", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },

                body: JSON.stringify({
                    id: id_agent_gptmaker
                })
            });
           
            if(resGptMakerAgenda0.status !== 200) {
                return { error: true, description: resGptMakerAgenda0.error };
            }
            
            await wait(500);

            
            //treinamento: informações do médico

            let trei01 = "# MÉDICO:"
            trei01 += "\nNome: " + getValues("medico")
            trei01 += "\nCRM: " + (getValues("crm") || "")
            trei01 += "\nEspecializações: " + getValues("especialidade")
            trei01 += "\nValor da Consulta: R$ " + Number(getValues("valor").replace(",", ".")).toFixed(2, 0)

            trei01 += "\n\n# LOCAL DE ATENDIMENTO:"
            trei01 += "\n" + getValues("logradouro")
            trei01 += "\nNúmero: " + (getValues("numero") || "")
            trei01 += "\nBairro: " + (getValues("bairro") || "")
            trei01 += "\nCidade: " + getValues("municipio")
            trei01 += "\nUF: " + getValues("uf")
            trei01 += "\nCEP: " + getValues("cep")
            trei01 += "\nEspecialidades e Pontos Relevantes: " + (getValues("description") || "")

            trei01 += "\n\n# REDES SOCIAIS:"
            trei01 += "\nweb site: " + (getValues("site").length > 0 ? getValues("site") : "sem informação")
            trei01 += "\ninstagram: " + (getValues("instagram").length > 0 ? getValues("instagram") : "sem informação")
            
            const resGptMakerAgenda1 = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/treinamento/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },

                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    texto: trei01
                })
            });
           
            if(resGptMakerAgenda1.status !== 200) {
                return { error: true, description: resGptMakerAgenda1.error };
            }
            
            await wait(500);
            
            //treinamento: avisos
            
            let trei02 = "# AVISOS! ATENÇÃO:"
            trei02 += "\n\nEste assistente é exclusivamente administrativo.";
            trei02 += "\n\nEle não realiza diagnósticos médicos, não avalia sintomas e não indica medicamentos.";
            trei02 += "\nQualquer dúvida clínica deve ser esclarecida diretamente com o médico durante a consulta."

            const resGptMakerAgenda2 = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/treinamento/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },

                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    texto: trei02
                })
            });
           
            if(resGptMakerAgenda2.status !== 200) {
                return { error: true, description: resGptMakerAgenda2.error };
            }
            
            await wait(500);

            //treinamento: atendimento
            
            let trei03 = "# ABERTURA DE ATENDIMENTO:";
            trei03 += "\n\nEste assistente sempre inicia o atendimento com a seguinte mensagem:";
            trei03 += "\n\n'Olá! Você está falando com o assistente virtual do Dr./Dra. [MEDICO]'";
            trei03 += "\nComo posso ajudá-lo(a)?";

            const resGptMakerAgenda3 = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/treinamento/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },

                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    texto: trei03
                })
            });
           
            if(resGptMakerAgenda3.status !== 200) {
                return { error: true, description: resGptMakerAgenda3.error };
            }
            
            await wait(500);
            
            //treinamento: exames
            let trei04 = "";

            if(exames.length > 0) {

                exames.map((item) => {
                    trei04 += item.descricao.length > 0 ? "Nome do Exame: " + item.exame + "\nValor do Exame: R$ " + item.valor.toFixed(2, 0) + "\nDescrição: " + item.descricao + "\n\n" : "Nome do Exame: " + item.exame + "\nValor do Exame: R$ " + item.valor.toFixed(2, 0) + "\n\n";
                })
            
            } else {
                trei04 = "O médico não realiza exames.";
            }

            trei04 = "# EXAMES:\n" + trei04;

            const resGptMakerExames = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/treinamento/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },

                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    texto: trei04
                })
            });
        
            if(resGptMakerExames.status !== 200) {
                return { error: true, description: resGptMakerExames.error };
            }

            await wait(500);

            //treinamento: convênios
            let trei05 = "";
            
            if(convenio) {

                selectedConvenios.map((item) => {
                    trei05 += "- " + item + "\n";
                })

                trei05 += "\n# LIMITE CONSULTAS/DIA:\n" + (getValues("numero_consultas") === 0 ? "limite=não há limite" : "limite=" + getValues("numero_consultas"));

            } else {
                trei05 = "O médico não aceita convênios."
            }

            trei05 = "# CONVÊNIOS ACEITOS:\n" + trei05

            const resGptMakerConvenios = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/treinamento/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },

                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    texto: trei05
                })
            });
        
            if(resGptMakerConvenios.status !== 200) {
                return { error: true, description: resGptMakerConvenios.error };
            }

            await wait(500);
            
            return { error: false, description: "" };
            
        }
        catch(erro) {
            return { error: true, description: erro };
        }
        
    }


    async function add_intencoes(id_agent_gptmaker) {

        try {
            
            //intencoes: primeira interação
            const resGptMakerIntencao1 = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/intencao/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },

                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    descricao: "agenda - primeira interação",
                    urlcloudrun: "https://agenda-services-712108985873.southamerica-east1.run.app/calendar/findfree",
                    detalhes: "quando o paciente fizer a primeira interação com o agente mencionando sobre disponibilidade de horários para agendar CONSULTAS, EXAMES ou RETORNOS"
                })
            });
           
            if(resGptMakerIntencao1.status !== 200) {
                return { error: true, description: resGptMakerIntencao1.error };
            }
            
            await wait(500);
            
            //intencoes: agenda localizar
            const resGptMakerIntencao2 = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/intencao/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },
                
                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    descricao: "agenda - localizar",
                    urlcloudrun: "https://agenda-services-712108985873.southamerica-east1.run.app/calendar/findschedule",
                    detalhes: "quando o paciente precisar confirmar o horário de um agendamento;\nquando o paciente não sabe ou esqueceu o horário de agendamento"
                })
            });
           
            if(resGptMakerIntencao2.status !== 200) {
                return { error: true, description: resGptMakerIntencao2.error };
            }
            
            await wait(500);
            
            //intencoes: agenda consultar dia
            const resGptMakerIntencao3 = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/intencao/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },
                
                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    descricao: "agenda - consultar dia",
                    urlcloudrun: "https://agenda-services-712108985873.southamerica-east1.run.app/calendar/findday",
                    detalhes: "quando o paciente solicita ver a disponibilidade de horários de um dia específico"
                })
            });
           
            if(resGptMakerIntencao3.status !== 200) {
                return { error: true, description: resGptMakerIntencao3.error };
            }
            
            await wait(500);
            
            //intencoes: agenda adicionar
            const resGptMakerIntencao4 = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/intencao/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },
                
                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    descricao: "agenda - adicionar",
                    urlcloudrun: "https://agenda-services-712108985873.southamerica-east1.run.app/calendar/add",
                    detalhes: "quando for agendar um horário de CONSULTA, EXAME ou RETORNO"
                })
            });
           
            if(resGptMakerIntencao4.status !== 200) {
                return { error: true, description: resGptMakerIntencao4.error };
            }
            
            await wait(500);

            //intencoes: agenda cancelar
            const resGptMakerIntencao5 = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/intencao/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },
                
                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    descricao: "agenda - cancelar",
                    urlcloudrun: "https://agenda-services-712108985873.southamerica-east1.run.app/calendar/cancel",
                    detalhes: "quando o paciente quiser cancelar uma CONSULTA, EXAME ou RETORNO"
                })
            });
           
            if(resGptMakerIntencao5.status !== 200) {
                return { error: true, description: resGptMakerIntencao5.error };
            }
            
            await wait(500);

            //intencoes: transferir para humano
            const resGptMakerIntencao6 = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/intencao/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },
                
                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    descricao: "recado para humano",
                    urlcloudrun: "https://agenda-services-712108985873.southamerica-east1.run.app/calendar/human_contact",
                    detalhes: "quando o agente não conseguir resolver um atendimento ou o paciente pedir para falar com o médico"
                })
            });
           
            if(resGptMakerIntencao6.status !== 200) {
                return { error: true, description: resGptMakerIntencao6.error };
            }

            return { error: false, description: "" };

        }
        catch(erro) {
            return { error: true, description: erro };
        }
        
    }


    async function make_line(idtel) {

        try {

            const telephoneref = doc(db, "telephones", idtel);
            await updateDoc(telephoneref, { status: 2 });

            return { error: false, description: "" };

        } 
        catch (erro) {
            return { error: true, description: "make_line " + erro };
        }

    }



    async function update_agent(idtel, tel) {
        
        try {

            const aid = basic.agent.id;
            const agentRef = doc(db, "agent", aid);
            const agora = new Date();

            await runTransaction(db, async (transaction) => {

                const agentSnap = await transaction.get(agentRef);

                const agentAtual = agentSnap.data();
                
                //1. salva histórico
                const histRef = doc(collection(db, "agent_hist"));

                transaction.set(histRef, {
                    ...agentAtual,
                    id_agent: aid,
                    data_inicio_vigencia: agentAtual.data_atualizacao,
                    data_fim_vigencia: agora,
                    archived_at: serverTimestamp()
                });

                //2. atualiza documento principal
                transaction.update(agentRef, {
                    data_atualizacao: agora,
                    data_inicio_ativacao: agora,
                    data_termino_ativacao: new Date("2100-12-31T23:59:59Z"),
                    status: 3,
                    telefone: tel
                });

            });
        
            await addDoc(collection(db, "uses"), 
            { 
                id_client: basic.client.id,
                id_agent: basic.agent.id,
                id_telephone: idtel,
                plano: basic.agent.plano,
                data_criacao: agora,
                data_inicio_vigencia: agora,
                data_termino_vigencia: new Date("2100-12-31T23:59:59Z"),
            })

            return { error: false, description: "" };

        }
        catch(erro) {
            return { error: true, description: "erro update_agent " + erro };
        }

    }


    async function create_agentgpt(idagentgpt) {

        try {

            let prmp01 = "Você é o assistente virtual de um médico(a) e deve seguir rigorosamente o fluxo abaixo para agendamentos.\nVocê NÃO pode pular etapas, assumir dados, inventar horários ou confirmar sem todas as informações obrigatórias.";
            
            let prmp02 = "\n\n# REGRAS GERAIS:"
            prmp02 += "\nNunca avance se faltar informação obrigatória"
            prmp02 += "\nPergunte sempre que algo não estiver claro"
            prmp02 += "\nUtilize apenas exames e convênios listados nos treinamentos"
            prmp02 += "\nRetorno não utiliza convênio e não possui limite"
            prmp02 += "\nNão misture fluxos (agendar, cancelar, localizar)"
            prmp02 += "\nUse somente dados retornados pelas rotas de agenda"
            prmp02 += "\nLimite de convênios é informação interna e NUNCA deve ser perguntada ao paciente"
            prmp02 += "\nQuando a resposta do paciente for clara e direta, considere a informação confirmada implicitamente"
            prmp02 += "\nNão peça confirmações de 'sim' ou 'não' durante o fluxo"
            prmp02 += "\nA confirmação explícita deve ocorrer apenas na etapa final"
            prmp02 += "\nNunca volte a perguntar uma etapa que já foi claramente definida na conversa"
            prmp02 += "\nQuando o tipo de atendimento puder ser inferido claramente pelo contexto (ex: exame informado), não pergunte novamente";
            
            let prmp03 = "\n\n# FLUXO OBRIGATÓRIO:"
            prmp03 += "\n1. Tipo de atendimento"
            prmp03 += "\nIdentifique se é consulta, exame (qual) ou retorno"
            prmp03 += "\nSe não informado, pergunte. Não avance sem isso"

            prmp03 += "\n\n2. Validação"
            prmp03 += "\nConsulta: válida"
            prmp03 += "\nExame: só se estiver nos treinamentos"
            prmp03 += "\nRetorno: válido e sem convênio"

            prmp03 += "\n\n3. Convênio ou particular"
            prmp03 += "\nSomente para consulta/exame"
            prmp03 += "\nSe convênio: validar se é aceito e respeitar limite diário"
            prmp03 += "\nRetorno ignora esta etapa"

            prmp03 += "\n\n4. Disponibilidade"
            prmp03 += "\nSomente após ter atendimento + convênio (ou retorno)"
            prmp03 += "\nBuscar agenda usando:"
            prmp03 += "\nagenda - primeira interação ou"
            prmp03 += "\nagenda - consultar dia"
            prmp03 += "\nNunca invente datas ou horários"

            prmp03 += "\n\n5. Escolha"
            prmp03 += "\nPaciente escolhe dia e hora válidos dentre as opções apresentadas"

            prmp03 += "\n\n6. Dados do paciente"
            prmp03 += "\nSolicitar nome completo e email somente após a escolha do horário"

            prmp03 += "\n\n7. Confirmação"
            prmp03 += "\nResumo obrigatório (atendimento, convênio, dia, hora, nome, email)"
            prmp03 += "\nSomente após confirmação executar agenda - adicionar"

            let prmp04 = "\n\n# CANCELAMENTO / LOCALIZAÇÃO:"
            prmp04 += "\nSe o paciente quiser localizar ou cancelar:"
            prmp04 += "\nExecutar agenda - localizar"
            prmp04 += "\nMostrar agendamentos"
            prmp04 += "\nConfirmar qual cancelar"
            prmp04 += "\nExecutar agenda - cancelar"
            prmp04 += "\nNunca misture com novo agendamento"

            let prmp05 = "\n\n# CONDUTA:"
            prmp05 += "\nUse linguagem clara e educada"
            prmp05 += "\nFormule apenas uma pergunta por mensagem"
            prmp05 += "\nEm caso de dúvida, interrompa o fluxo e pergunte"
            prmp05 += "\nNunca verbalize regras internas ao paciente"

            let prmp06 = "\n\n# OBJETIVO:"
            prmp06 += "\nRealizar agendamentos corretos, sem erros, sem pular etapas e sem dados inválidos"

            const prompt = prmp01 + prmp02 + prmp03 + prmp04 + prmp05 + prmp06;

            const resGptMaker = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/agent/update", { 
                method: "POST", 
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: idagentgpt,
                    name: basic.agent.nome,
                    behavior: prompt,
                    jobname: "Médicos",
                    jobdescription: getValues("description")
                })
            });
            
            if(resGptMaker.status === 200) {
                return { error: false, description: "" };
            } 
            
        }
        catch (error) {

            if (error.response) {
                return { error: true, description: "API GptMaker Erro - " + error.response.data };
            } else {
                return { error: true, description: "API GptMaker Falha - " + error.message };
            }
            
        }
 
    }


    async function find_address() {

        let cp = getValues("cep");
        if(cp.length < 9) {
            setError("cep");
            setValue("logradouro", "");
            setValue("bairro", "");
            setValue("municipio", "");
            setValue("uf", "");
            showError(refCep, refLabelCep, refErrorCep, "Insira um CEP com oito digitos", setError, "cep");
            return;
        }

        startTransition( async() => {
        try {

            cp = cp.replace('-', '');
            const rcep = await fetch(`https://viacep.com.br/ws/${cp}/json/`);
            
            rcep.json().then(data => {

            if(data.erro === "true") {
                setValue("logradouro", "");
                setValue("bairro", "");
                setValue("municipio", "");
                setValue("uf", "");
                setError("cep");
                showError(refCep, refLabelCep, refErrorCep, "Esse CEP não foi localizado, verifique a digitação", setError, "cep");
            } else {
                setValue("logradouro", data.logradouro);
                setValue("bairro", data.bairro);
                setValue("municipio", data.localidade);
                setValue("uf", data.uf);
                refNumero.current.focus();
            }

            });

        }
        catch(erro) {
            console.log(erro);
        }
        })
        
    }

    function vinsta(e) {
        if (e.length >0 && !e.startsWith("@")) {
            setValue("instagram", "@" + e.replace(/@/g, ""));
        }
    }

    
    function back_step(stp) {

        setStep(stp);
        window.scrollTo(0, 0);

    }
    

    //-- funções para exames -----------------------------------------------------------------------------------------------
    function add_exame() {

        let ne = getValues("exame");
        if(ne.length < 3) {
            showError(refExame, refLabelExame, refErrorExame, "Você deve inserir um nome para seu exame", setError, "exame");
            return;
        }

        let ve = getValues("valor_exame").replace(",", ".");
        if(ve.length === 0 || isNaN(Number(ve))) {
            showError(refValorExame, refLabelValorExame, refErrorExame, "Insira um valor válido em reais para seu exame", setError, "exame_valor");
            return;
        }

        let de = getValues("descricao_exame");

        setExames(ex => [...ex, {id: uuidv4(), exame: ne, valor: Number(ve), descricao: de}]);

        setValue("exame", "");
        setValue("valor_exame", "");
        setValue("descricao_exame", "");
        refExame.current.focus();
        
    }

    function remove_exame(id) {
        setExames(prev => prev.filter(exame => exame.id !== id));
    }

    function toggleExame(id) {
        setExamesOpen(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    }

    function startEditExame(id) {

        const exame = exames.find(e => e.id === id);

        setExameEditando(id);
        setExameDraft({ ...exame });
    
    }

    function cancelEditExame() {
        setExameEditando(null);
        setExameDraft(null);
    }


    function confirmEditExame(id) {
    
        const ne = exameDraft.exame;
        const ve = String(exameDraft.valor).replace(",", ".");

        if(ne.length < 3) {
            setExamesErrors(prev => ({...prev, [id]: "Você deve inserir um nome para seu exame"}));
            return;
        }

        if(ve.length === 0 || isNaN(Number(ve))) {
            setExamesErrors(prev => ({...prev, [id]: "Insira um valor válido em reais para seu exame"}));
            return;
        }

        setExames(prev => prev.map(e => e.id === id ? { ...e, ...exameDraft, valor: Number(ve) } : e ));

        setExameEditando(null);
        setExameDraft(null);
    }
    // ----------------------------------------------------------------------------------------------------------------------


    function accept_terms() {

        if(refCheckBox.current.checked) {
            refErrorTerms.current.innerHTML = "";
            refErrorTerms.current.style.height = "0rem";
        }

    }


    //-- funções para a criação e gerenciamento do calendário --------------------------------------------------------------
    function create_calendar() {

        formError(refError, "", false);

        const tp = Number(getValues("tempo_atendimento"));

        if(tp < 30 || tp > 180 || tp % 15 !== 0) {
            showError(refTempoAtendimento, refLabelTempoAtendimento, refErrorTempoAtendimento, "O intervalo de tempo deve ser entre 30 e 180 minutos e ser multiplo de 15 minutos", setError, "tempo_atendimento");
            return;
        }

        const calendar = {};
        const baseMonday = getWeekRange().monday;

        const startHour = 0;
        const endHour = 23;

        for(let i = 0; i < 91; i++) {

            const date = new Date(baseMonday);
            date.setDate(baseMonday.getDate() + i);

            const dayId = dateToYYYYMMDD(date);

            const horarios = {};

            const totalMinutes = (endHour - startHour + 1) * 60;

            for(let min = 0; min < totalMinutes; min += tp) {

                const total = startHour * 60 + min;
                const hour = Math.floor(total / 60);
                const minute = total % 60;

                const label = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
                horarios[label] = { status: "indisponivel" };

            }

            calendar[dayId] = {blocked_day: false, blocked_reason: "", interval: tp, updated_at: new Date("2100-12-31T23:59:59Z"), horarios};
        }

        const endMonday = new Date(baseMonday);
        endMonday.setDate(baseMonday.getDate() + (12 * 7));

        setMondayStart(baseMonday);
        setMondayEnd(endMonday);

        setMondayBase(baseMonday);
        setTempoAtendimento(tp);
        setShowCalendar(true);
        setCalendario(calendar);

    }


    function MedicalCalendar({refCalendario, calendario}) {

        const baseDayId = dateToYYYYMMDD(mondayBase);
        const firstDay = calendario?.[baseDayId];
        const horariosArray = firstDay ? Object.entries(firstDay.horarios) : [];

        return (
            <div className="medical_calendar" ref={refCalendario}>
                <span className="title_form">Defina sua agenda diária</span>
                <span className="subtitle_form">Defina seus dias e horários de disponibilidade para atendimento clicando no dia-horário específico.</span>
                <span className="medical_observacao">Você não precisa definir cada dia individualmente, basta definir os horários da semana e clicar no botão "replicar para todas as semanas". Entretanto, caso queira, você pode configurar os horários de uma semana ou dia específicos, rolando nas setas do calendário e personalizando qualquer período.</span>

                <span className="medical_calendar_space"></span>
                <div className="medical_calendar_frame">
                    <div className="medical_calendar_day"></div>
                    <div className="medical_calendar_week_group">
                        <div className="medical_calendar_week">Semana:&nbsp;<span className="medical_calendar_week_date">{formatTimestamp(mondayBase)}</span>&nbsp;a&nbsp;<span className="medical_calendar_week_date">{formatTimestamp(addDays(mondayBase, 6))}</span></div>
                        <div className="medical_calendar_weekmove_group">
                            <div className="medical_calendar_weekmovea" style={{cursor: mondayBase.getTime() === mondayStart.getTime() ? "" : "pointer"}} onClick={() => moveWeek(-7)}><img className="medical_calendar_seta" src={mondayBase.getTime() === mondayStart.getTime() ? seta_prev_off : seta_prev_on}></img></div>
                            <div className="medical_calendar_weekmoveb" style={{cursor: mondayBase.getTime() === mondayEnd.getTime() ? "" : "pointer"}} onClick={() => moveWeek(7)}><img className="medical_calendar_seta" src={mondayBase.getTime() === mondayEnd.getTime() ? seta_next_off : seta_next_on}></img></div>
                        </div>
                    </div>
                </div>
                <span className="medical_calendar_space"></span>

                <div className="medical_calendar_frame">
                    <span className="medical_calendar_day"></span>
                    <span className="medical_calendar_day" style={{color: "var(--CNZ_2)"}} data-short={formatTimestamp(addDays(mondayBase, 0)).substring(0, 5)}>{formatTimestamp(addDays(mondayBase, 0))}</span>
                    <span className="medical_calendar_day" style={{color: "var(--CNZ_2)"}} data-short={formatTimestamp(addDays(mondayBase, 1)).substring(0, 5)}>{formatTimestamp(addDays(mondayBase, 1))}</span>
                    <span className="medical_calendar_day" style={{color: "var(--CNZ_2)"}} data-short={formatTimestamp(addDays(mondayBase, 2)).substring(0, 5)}>{formatTimestamp(addDays(mondayBase, 2))}</span>
                    <span className="medical_calendar_day" style={{color: "var(--CNZ_2)"}} data-short={formatTimestamp(addDays(mondayBase, 3)).substring(0, 5)}>{formatTimestamp(addDays(mondayBase, 3))}</span>
                    <span className="medical_calendar_day" style={{color: "var(--CNZ_2)"}} data-short={formatTimestamp(addDays(mondayBase, 4)).substring(0, 5)}>{formatTimestamp(addDays(mondayBase, 4))}</span>
                    <span className="medical_calendar_day" style={{color: "blue"}} data-short={formatTimestamp(addDays(mondayBase, 5)).substring(0, 5)}>{formatTimestamp(addDays(mondayBase, 5))}</span>
                    <span className="medical_calendar_day" style={{color: "red"}} data-short={formatTimestamp(addDays(mondayBase, 6)).substring(0, 5)}>{formatTimestamp(addDays(mondayBase, 6))}</span>
                </div>
                <div className="medical_calendar_frame">
                    <span className="medical_calendar_title"></span>
                    <span className="medical_calendar_title" style={{color: "var(--CNZ_2)"}} data-short="Seg">Segunda</span>
                    <span className="medical_calendar_title" style={{color: "var(--CNZ_2)"}} data-short="Ter">Terça</span>
                    <span className="medical_calendar_title" style={{color: "var(--CNZ_2)"}} data-short="Qua">Quarta</span>
                    <span className="medical_calendar_title" style={{color: "var(--CNZ_2)"}} data-short="Qui">Quinta</span>
                    <span className="medical_calendar_title" style={{color: "var(--CNZ_2)"}} data-short="Sex">Sexta</span>
                    <span className="medical_calendar_title" style={{color: "blue"}} data-short="Sáb">Sábado</span>
                    <span className="medical_calendar_title" style={{color: "red"}} data-short="Dom">Domingo</span>
                </div>

                {firstDay && Object.entries(firstDay.horarios).sort(([h1], [h2]) => h1.localeCompare(h2)).map(([hora, info], hIndex) => (

                    <div className="medical_calendar_frame" key={hora}>
                        <span className="medical_calendar_hours">{hora}</span>

                        {[0,1,2,3,4,5,6].map((offset) => {

                            const dayDate = addDays(mondayBase, offset);
                            const dayNumber = dateToYYYYMMDD(dayDate);

                            /*
                            const today = new Date();
                            today.setHours(0, 0, 0, 0);

                            const isPastOrToday = dayDate <= today;
                            */

                            const slot = calendario?.[dayNumber]?.horarios?.[hora];

                            let colorcell = "";

                            //if(isPastOrToday) {
                            //    colorcell = "var(--HEAD_BK)";
                            //} else {
                                if(slot?.status === "indisponivel") {

                                    if(offset === 5) {
                                        colorcell = "#f2f6ff";
                                    } else if(offset === 6) {
                                        colorcell = "#fff2f2";
                                    } else {
                                        colorcell = "white";
                                    }

                                } else if(slot?.status === "livre") {
                                    colorcell = "yellow";
                                } else {
                                    colorcell = "red";
                                }
                            //}

                            return (<span key={offset} className={/*isPastOrToday ? "medical_calendar_days_unavailable" : */slot?.status === "indisponivel" ? "medical_calendar_days_available" : slot?.status === "livre" ? "medical_calendar_days_selected" : "medical_calendar_days_occupied"} style={{...(offset === 0 ? { borderLeft: "solid 1px var(--CNZ_3)" } : {}), ...(hIndex === horariosArray.length - 1 ? { borderBottom: "solid 1px var(--CNZ_3)" } : {}), backgroundColor: colorcell}} onClick={() => {/*if (isPastOrToday) return;*/ handleToggleSlot(dayNumber, hora);}}>{/*isPastOrToday ? "" : */slot?.status === "indisponivel" ? "" : slot?.status}</span>);
                        
                        })}
                    </div>
                ))}

                <span className="space_form"></span>
                <div className="medical_calendar_frame">
                    <div className="medical_calendar_day"></div>
                    <div className="medical_calendar_message">
                        <span className="medical_observacao">Clicando no botão abaixo, iremos replicar seus dias-horários de disponibilidade a todas as demais semanas, baseando-se na configuração da semana que você está visualizando.</span>
                    </div>
                </div>
                <span className="medical_calendar_space"></span>
                <div className="medical_calendar_frame">
                    <div className="medical_calendar_day"></div>
                    <div className="medical_calendar_message">
                        <span className="medical_observacao">Para tornar algum dia ou período indisponível, por motivo de feriado, férias ou qualquer outro motivo, basta clicar no dia/horário e apagar a disponibilidade.</span>
                    </div>
                </div>

                <span className="medical_calendar_space"></span>
                <div className="medical_calendar_frame">
                    <div className="medical_calendar_day"></div>
                    <div className="medical_calendar_message">
                        <button type="button" name="bt4b" ref={refButtonReplicateAll} className="button2_form" onClick={replicateAll} disabled={replicando}>{replicando ? "REPLICANDO ..." : "REPLICAR PARA TODAS AS SEMANAS"}</button>
                    </div>
                </div>
            
            </div>
        );
    }


    function handleToggleSlot(dayNumber, hora) {

        setCalendario(prev => {

            const day = prev?.[dayNumber];
            if(!day) return prev;

            const slot = day.horarios?.[hora];
            if(!slot) return prev;

            //horário ocupado não pode ser alterado
            if(slot.status === "ocupado") return prev;

            const newStatus = slot.status === "livre" ? "indisponivel" : slot.status === "indisponivel" ? "livre": slot.status;

            return {...prev, [dayNumber]: {...day, horarios: {...day.horarios, [hora]: {...slot, status: newStatus}}}};
        
        });
    }


    useEffect(() => { if (!calendario) { setDsp(0); return; } let totalLivres = 0; Object.values(calendario).forEach(day => { Object.values(day.horarios || {}).forEach(slot => { if (slot?.status === "livre") { totalLivres++; } }); }); setDsp(totalLivres); }, [calendario]);

    useEffect(() => { if (dsp > 0) { formError(refError, "", false); }}, [dsp]);

        
    function moveWeek(move) {
    
        setMondayBase(prev => {
        const nova = new Date(prev);
        nova.setDate(nova.getDate() + move);

        if (nova < mondayStart) return prev;
        if (nova > mondayEnd) return prev;

        return nova;
    
        });
    }


    function replicateAll() {

        setReplicando(true);

        setCalendario(prev => {

            const novo = { ...prev };

            //1. semana base (a que está sendo visualizada)
            const baseWeek = {};

            for(let i = 0; i < 7; i++) {
                const date = new Date(mondayBase);
                date.setDate(mondayBase.getDate() + i);

                const dayId = dateToYYYYMMDD(date);
                const dayOfWeek = date.getDay();

                if(novo[dayId]) {
                    baseWeek[dayOfWeek] = novo[dayId].horarios;
                }
            }

            //limite: fim da semana atual
            const endOfBaseWeek = new Date(mondayBase);
            endOfBaseWeek.setDate(endOfBaseWeek.getDate() + 6);
            endOfBaseWeek.setHours(23, 59, 59, 999);

            //2. replica SOMENTE semanas futuras
            Object.keys(novo).forEach(dayId => {

                const date = new Date(dayId.slice(0, 4), dayId.slice(4, 6) - 1, dayId.slice(6, 8));

                //ignora semana atual e anteriores
                if(date <= endOfBaseWeek) return;

                const dayOfWeek = date.getDay();
                const baseHorarios = baseWeek[dayOfWeek];
                if(!baseHorarios) return;

                const horariosAtuais = novo[dayId].horarios;
                const horariosAtualizados = { ...horariosAtuais };

                Object.entries(baseHorarios).forEach(([hora, baseSlot]) => {

                    //nunca replica ocupado da semana base
                    if(baseSlot.status === "ocupado") return;

                    const atualSlot = horariosAtuais[hora];

                    //nunca sobrescreve ocupado no destino
                    if(atualSlot?.status === "ocupado") return;

                    horariosAtualizados[hora] = {...atualSlot, status: baseSlot.status};
            
                });

                novo[dayId] = {...novo[dayId], horarios: horariosAtualizados};
        
            });

            return novo;
    
        });

        setTimeout(() => { setReplicando(false); }, 3000);

    }


    async function cria_agenda(id_agent, calendario) {

        for(const [diaId, dia] of Object.entries(calendario)) {

            const horariosMap = {};

            Object.entries(dia.horarios).forEach(([hora, slot]) => {
                horariosMap[hora] = { status: slot.status };
            });

            const diaRef = doc(db, "calendar", id_agent, "dias", diaId);

            await setDoc(diaRef, {blocked_day: false, blocked_reason: "", interval: dia.interval, updated_at: new Date("2100-12-31T23:59:59Z"), horarios: horariosMap});
        }
    }


    async function altera_agenda(id_agent, calendario) {

        const hojeId = dateToYYYYMMDD(new Date());

        for (const [diaId, diaFront] of Object.entries(calendario)) {

            //1️. não mexe em dias passados
            if(diaId < hojeId) continue;

            const diaRef = doc(db, "calendar", id_agent, "dias", diaId);
            const diaSnap = await getDoc(diaRef);

            if(!diaSnap.exists()) continue;

            const diaDb = diaSnap.data();
            const horariosAtualizados = { ...diaDb.horarios };

            //2️. percorre todos os horários
            Object.entries(diaFront.horarios || {}).forEach(([hora, slotFront]) => {

                const slotDb = diaDb.horarios?.[hora];
                if(!slotDb) return;

                //nunca mexe em ocupado
                if(slotDb.status === "ocupado") return;

                //3. só permite livre <-> indisponivel
                if((slotDb.status === "livre" || slotDb.status === "indisponivel") && slotDb.status !== slotFront.status) {
                    horariosAtualizados[hora] = {...slotDb, status: slotFront.status};
                }
            });

            await setDoc(diaRef, {horarios: horariosAtualizados, updated_at: new Date()}, { merge: true });
        }
    }
    // ----------------------------------------------------------------------------------------------------------------------



    return(

        <div className="context">
        
            <Header access={1}></Header>
        
            <div className="content">

                { step === 0 && 
                (
                <>
                <div className="ft_topico">Configurar agente</div>
                <div className="ft_descricao">Chegou a hora de configurar seu agente, essa é uma etapa muito importante, aqui você definirá todas as regras para que seu agente possa dar o melhor atendimento a seus clientes.</div>
                <div className="space"></div>

                <div className="border_form medical_border_form">
                    <form className="form">

                        {loadBasic ? (<span className="load_form">carregando ...</span>) : (
                        <>
                        
                        <span className="step_form">
                            <span className="step_form_number">Passo 1/4</span>
                            <span className="step_form_description">&nbsp;. Informações Gerais</span>
                        </span>
                    
                        <span className="space_form"></span>

                        <span className="title_form">Clínica ou local de atendimento</span>
                        <span className="subtitle_form">Informações cadastradas sobre a clínica ou local de atendimento do médico.</span>
                        
                        <label for="inp" className="inp">
                        <input type="text" placeholder="&nbsp;" {...register("empresa")} disabled={true}></input>
                        <span className="label">Empresa</span>
                        <span className="focus-bg"></span>
                        </label>
                        <span className="space_form"></span>

                        <span className="subtitle_form">Descreva as especialidades da clínica ou fatores que você julgue relevantes para que seus clientes saibam.</span>
                        <span className="subtitle_form">O agente fornecerá essas qualificações a seus clientes.</span>
                        
                        <span ref={refErrorDescription} className="error_form"></span>
                        <label for="inp2" className="inp2" ref={refLabelDescription}>
                        <textarea placeholder="&nbsp;" {...register("description")} maxLength={400} ref={(el) => {refDescription.current = el; register("description").ref(el);}} onClick={() => clearError(refDescription, refLabelDescription, refErrorDescription, error, setError)} onChange={() => clearError(refDescription, refLabelDescription, refErrorDescription, error, setError)}></textarea>
                        <span class="label2">Especialidades e pontos relevantes</span>
                        <span class="focus-bg2"></span>
                        </label>
                        <span className="space_form"></span>

                        <span className="title_form">Endereço</span>
                        <span className="subtitle_form">O agente fornecerá sempre que perguntado o endereço.</span>
                        <span className="medical_observacao">Para facilitar, digite o CEP e clique em "buscar endereço".</span>
                
                        <span ref={refErrorCep} className="error_form"></span>
                        <div className="medical_box01">

                            <div className="medical_box01a">
                                <label for="inp" className="inp" ref={refLabelCep}>
                                <input type="text" placeholder="&nbsp;" maxLength={9} {...register("cep")} onKeyDown={(e) => {if (e.key === "Enter") {find_address();}}} ref={(el) => {refCep.current = el; register("cep").ref(el);}} onClick={() => clearError(refCep, refLabelCep, refErrorCep, error, setError)} onChange={(e) => {if (error === "0") {setValue("cep", maskcep(e.target.value));} else {clearError(refCep, refLabelCep, refErrorCep, error, setError);}}}></input>
                                <span className="label">CEP</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                            <div className="medical_box01b"></div>

                            <div className="medical_box01c">
                                <button type="button" name="bt1" className={ isPending ? "buttonsearch_disabled_form" : "buttonsearch_form" } onClick={ find_address }>{ isPending ? "AGUARDE ..." : "BUSCAR ENDEREÇO" }</button>
                            </div>

                            <div className="medical_box01d"></div>

                        </div>
                        <span className="space_form"></span>

                        <span ref={refErrorLogradouro} className="error_form"></span>
                        <div className="medical_box">

                            <div className="medical_box02a">
                            <label for="inp" className="inp" ref={refLabelLogradouro}>
                            <input type="text" placeholder="&nbsp;" maxLength={60} {...register("logradouro")} ref={(el) => {refLogradouro.current = el; register("logradouro").ref(el);}} onClick={() => clearError(refLogradouro, refLabelLogradouro, refErrorLogradouro, error, setError)} onChange={() => clearError(refLogradouro, refLabelLogradouro, refErrorLogradouro, error, setError)}></input>
                            <span className="label">Logradouro</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                            <div className="medical_box02b"></div>

                            <div className="medical_box02c">
                            <label for="inp" className="inp" ref={refLabelNumero}>
                            <input type="text" placeholder="&nbsp;" maxLength={8} {...register("numero")} ref={(el) => {refNumero.current = el; register("numero").ref(el);}} onClick={() => clearError(refNumero, refLabelNumero, refErrorLogradouro, error, setError)} onChange={() => clearError(refNumero, refLabelNumero, refErrorLogradouro, error, setError)}></input>
                            <span className="label">Número</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                        </div>
                        <span className="space_form"></span>

                        <span ref={refErrorMunicipio} className="error_form"></span>
                        <div className="medical_box">

                            <div className="medical_box02a">
                            <label for="inp" className="inp">
                            <input type="text" id="bairro" placeholder="&nbsp;" maxLength={30} {...register("bairro")}></input>
                            <span className="label">Bairro</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                            <div className="medical_box02b"></div>

                            <div className="medical_box02c">
                            <label for="inp" className="inp">
                            <input type="text" id="complemento" placeholder="&nbsp;" maxLength={15} {...register("complemento")}></input>
                            <span className="label">Complemento</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                        </div>
                        <span className="space_form"></span>

                        <div className="medical_box">

                            <div className="medical_box02a">
                            <label for="inp" className="inp" ref={refLabelMunicipio}>
                            <input type="text" placeholder="&nbsp;" maxLength={30} {...register("municipio")} ref={(el) => {refMunicipio.current = el; register("municipio").ref(el);}} onClick={() => clearError(refMunicipio, refLabelMunicipio, refErrorMunicipio, error, setError)} onChange={() => clearError(refMunicipio, refLabelMunicipio, refErrorMunicipio, error, setError)}></input>
                            <span className="label">Município</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                            <div className="medical_box02b"></div>

                            <div className="medical_box02c">
                            <label for="inp" className="inp" ref={refLabelUf}>
                            <input type="text" placeholder="&nbsp;" maxLength={2} {...register("uf")} ref={(el) => {refUf.current = el; register("uf").ref(el);}} onClick={() => clearError(refUf, refLabelUf, refErrorMunicipio, error, setError)} onChange={() => clearError(refUf, refLabelUf, refErrorMunicipio, error, setError)}></input>
                            <span className="label">UF</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>
                            
                        </div>
                        <span className="space_form"></span>

                        <span className="title_form">Web site e redes sociais</span>
                        <span className="subtitle_form">O agente poderá fornecer sempre que perguntado o web site e a rede social da clínica.</span>
                
                        <span ref={refErrorSite} className="error_form"></span>
                        <div className="medical_box">

                            <div className="medical_box02a">
                            <label for="inp" className="inp" ref={refLabelSite}>
                            <input type="text" id="site" placeholder="&nbsp;" maxLength={50} {...register("site")} ref={(el) => {refSite.current = el; register("site").ref(el);}} onClick={() => clearError(refSite, refLabelSite, refErrorSite, error, setError)} onChange={() => clearError(refSite, refLabelSite, refErrorSite, error, setError)}></input>
                            <span className="label">Web Site</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                            <div className="medical_box02b"></div>

                            <div className="medical_box02c">
                            <label for="inp" className="inp" ref={refLabelInsta}>
                            <input type="text" placeholder="&nbsp;" maxLength={30} {...register("instagram")} ref={(el) => {refInsta.current = el; register("instagram").ref(el);}} onClick={() => clearError(refInsta, refLabelInsta, refErrorSite, error, setError)} onChange={(e) => {if (error === "0") {vinsta(e.target.value);} else {clearError(refInsta, refLabelInsta, refErrorSite, error, setError);}}}></input>
                            <span className="label">Instagram</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                        </div>
                        <span className="space_form"></span>

                        <span className="title_form">Recado para o médico(a)</span>
                        <span className="subtitle_form">Em determinadas situações o agente pode não ter a resposta ou a informação necessária, ou simplesmente possa surgir algum tema sensível onde ele não consigar concluir o atendimento ao paciente. Nesses casos, nosso agente da winners deixará um recado para o médico com o contato do paciente para que ele possa entrar em contato em um momento mais oportuno com seu paciente.</span>
                        <span className="subtitle_form">Número para recados:</span>

                        <span ref={refErrorTelefone} className="error_form"></span>
                        <div className="medical_box">
                            <div className="medical_box03a">
                                <label for="inp" className="inp" ref={refLabelTelefone}>
                                <input type="text" placeholder="&nbsp;" maxLength={15} {...register("telefone_humano")} ref={(el) => {refTelefone.current = el; register("telefone_humano").ref(el);}} onClick={() => clearError(refTelefone, refLabelTelefone, refErrorTelefone, error, setError)} onChange={(e) => {if (error === "0") {setValue("telefone_humano", masktelefone(e.target.value));} else {clearError(refTelefone, refLabelTelefone, refErrorTelefone, error, setError);}}}></input>
                                <span className="label">Telefone</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="medical_box03b"></div>
                        </div>

                        <span className="space_form"></span>
                        <span className="space_form"></span>
                        <button type="button" name="bt1a" className="button_form" onClick={medical_step1}>AVANÇAR</button>
                        </>
                        )}

                    </form>
                </div>                    
                </>
                )}


                { step === 1 &&
                (
                <>
                <div className="ft_topico">Configurar agente</div>
                <div className="ft_descricao">Chegou a hora de configurar seu agente, essa é uma etapa muito importante, aqui você definirá todas as regras para que seu agente possa dar o melhor atendimento a seus clientes.</div>
                <div className="space"></div>

                <div className="border_form medical_border_form">
                    <form className="form">

                        <span className="step_form">
                            <span className="step_form_number">Passo 2/4</span>
                            <span className="step_form_description">&nbsp;. Informações do Médico</span>
                        </span>

                        <span className="space_form"></span>

                        <span className="title_form">Identificação do médico</span>
                        <span className="subtitle_form">Preencha as informações sobre o médico.</span>
                        <span className="subtitle_form">Quanto mais informações você inserir em especialidades e informações relevantes, mais completo seu agente ficará.</span>

                        <span className="error_form" ref={refErrorMedico}></span>
                        <div className="medical_box">

                            <div className="medical_box04a">
                                <label for="inp" className="inp" ref={refLabelMedico}>
                                <input type="text" placeholder="&nbsp;" maxLength={60} {...register("medico")} ref={(el) => {refMedico.current = el; register("medico").ref(el);}} onClick={() => clearError(refMedico, refLabelMedico, refErrorMedico, error, setError)} onChange={() => clearError(refMedico, refLabelMedico, refErrorMedico, error, setError)}></input>
                                <span className="label">Nome do Médico</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                            <div className="medical_box04b"></div>

                            <div className="medical_box04c">
                                <label for="inp" className="inp">
                                <input type="text" placeholder="&nbsp;" maxLength={10} {...register("crm")}></input>
                                <span className="label">CRM (opcional)</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                        </div>

                        <span className="space_form"></span>

                        <span className="error_form" ref={refErrorEspecialidade}></span>
                        <label for="inp2" class="inp2" ref={refLabelEspecialidade}>
                        <textarea placeholder="&nbsp;" {...register("especialidade")} maxLength={400} ref={(el) => {refEspecialidade.current = el; register("especialidade").ref(el);}} onClick={() => clearError(refEspecialidade, refLabelEspecialidade, refErrorEspecialidade, error, setError)} onChange={() => clearError(refEspecialidade, refLabelEspecialidade, refErrorEspecialidade, error, setError)}></textarea>
                        <span class="label2">Especialidades e informações relevantes</span>
                        <span class="focus-bg2"></span>
                        </label>
                            
                        <span className="space_form"></span>

                        <span className="title_form">Consulta</span>
                        <span className="subtitle_form">Indique o valor da sua consulta, caso seja agendado na modalidade particular.</span>

                        <span className="error_form" ref={refErrorValor}></span>
                        <div className="medical_box">
                            <div className="medical_box05a">
                                <label for="inp" className="inp" ref={refLabelValor}>
                                <input type="text" placeholder="&nbsp;" maxLength={8} {...register("valor")} ref={(el) => {refValor.current = el; register("valor").ref(el);}} onClick={() => clearError(refValor, refLabelValor, refErrorValor, error, setError)} onChange={() => clearError(refValor, refLabelValor, refErrorValor, error, setError)} onKeyDown={(e) => {if (!/[0-9,]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {e.preventDefault();}}}></input>
                                <span className="label">Valor (R$)</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="medical_box05b"></div>
                        </div>

                        <span className="space_form"></span>

                        <span className="title_form">Convênios</span>
                        <span className="subtitle_form">Caso aceite convênios, clique em 'selecionar convênios' e marque todos os convênios que você aceita.</span>

                        <div className="medical_convenio_box">
                            <div className="medical_convenio_option">
                                <input type="radio" name="radio_convenio" value="false" className="radio_custom" checked={convenio === false} onChange={handleChange}></input>
                                <span className="medical_convenio_option_text">Não aceito convênios</span>
                            </div>
                            <div className="medical_convenio_option">
                                <input type="radio" name="radio_convenio" value="true" className="radio_custom" checked={convenio === true} onChange={handleChange}></input>
                                <span className="medical_convenio_option_text">Selecionar convênios</span>
                            </div>
                        </div>
                        <span className="space_form"></span>

                        <span ref={refErrorConvenio} className="error_form"></span>

                        <div ref={refConvenio} className="medical_convenio_frame">
                            <div className="medical_convenio_itens">
                            {convenios.map((nome) => (
                            <div key={nome} className="medical_convenio_item">
                                <input type="checkbox" className="checkbox_default" disabled={!convenio} checked={selectedConvenios.includes(nome)} onChange={() => handleConvenioToggle(nome)} />
                                <span className="medical_convenio_item_text" style={{color: selectedConvenios.includes(nome) ? "var(--SEC_1)" : "var(--CNZ_2)"}}>{nome}</span>
                            </div>
                            ))}
                            <div className="medical_convenio_add">
                                <span className={`medical_convenio_add_button ${convenio ? "ativo" : ""}`} style={{cursor: convenio ? "pointer" : "default"}} onClick={() => {if (!convenio) return; setShowModalConvenio(true);}}>+ Adicionar convênio</span>
                            </div>
                            </div>
                            {showModalConvenio && (<div className="modal_background">
                            <div className="modal_convenio">
                            <span className="title_form">Novo convênio</span>

                            <label for="inp" className="inp">
                            <input type="text" placeholder="&nbsp;" value={novoConvenio} onChange={(e) => setNovoConvenio(e.target.value)}></input>
                            <span className="label">Nome</span>
                            <span className="focus-bg"></span>
                            </label>
                            <span className="space_form"></span>

                            <div className="medical_convenio_new_group">
                                <div className="medical_convenio_new_buttons"><button type="button" name="bt2b" className="button2_form" onClick={() => {setNovoConvenio(""); setShowModalConvenio(false);}}>CANCELAR</button></div>
                                <div className="medical_convenio_new_buttons"><button type="button" name="bt2b" className="button_form" onClick={() => { const nome = novoConvenio.trim(); if (!nome) return; if (!convenios.includes(nome)) { setConvenios(prev => [...prev, nome]); } handleConvenioToggle(nome); setNovoConvenio(""); setShowModalConvenio(false); }}>ADICIONAR</button></div>
                            </div>
                            </div>
                            </div>
                            )}
                        </div>

                        <span className="space_form"></span>
                        <span className="subtitle_form">Caso aceite convênios, você pode restringir o número máximo de consultas conveniadas que você aceita por dia.</span>
                        <span className="subtitle_form">0 = Sem limite de consultas conveniadas por dia.</span>

                        <span className="error_form" ref={refErrorNumeroConsultas}></span>
                        <div className="medical_box">
                            <div className="medical_box05a">
                                <label for="inp" className="inp" ref={refLabelNumeroConsultas}>
                                <input type="text" placeholder="&nbsp;" maxLength={2} {...register("numero_consultas")} ref={(el) => {refNumeroConsultas.current = el; register("numero_consultas").ref(el);}} onClick={() => clearError(refNumeroConsultas, refLabelNumeroConsultas, refErrorNumeroConsultas, error, setError)} onChange={() => clearError(refNumeroConsultas, refLabelNumeroConsultas, refErrorNumeroConsultas, error, setError)} onKeyDown={(e) => {if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {e.preventDefault();}}} disabled={!convenio}></input>
                                <span className="label">Número de Consultas</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="medical_box05b"></div>
                        </div>

                        <span className="space_form"></span>
                        <span className="space_form"></span>
                        
                        <div className="medical_buttons_box">
                            <div className="medical_box08a">
                                <button type="button" name="bt2a" className="button2_form" onClick={(e) => back_step(0)}>VOLTAR</button>
                            </div>
                            <div className="medical_box08b"></div>
                            <div className="medical_box08c">
                                <button type="button" name="bt2b" className="button_form" onClick={medical_step2}>AVANÇAR</button>
                            </div>
                        </div>

                    </form>
                </div>
                </>
                )}


                { step === 2 &&
                (
                <>
                <div className="ft_topico">Configurar agente</div>
                <div className="ft_descricao">Chegou a hora de configurar seu agente, essa é uma etapa muito importante, aqui você definirá todas as regras para que seu agente possa dar o melhor atendimento a seus clientes.</div>
                <div className="space"></div>

                <div className="border_form medical_border_form">
                    <form className="form">

                        <span className="step_form">
                            <span className="step_form_number">Passo 3/4</span>
                            <span className="step_form_description">&nbsp;. Exames / Procedimentos</span>
                        </span>

                        <span className="space_form"></span>
                
                        { exames.length > 0 && (<><span className="subtitle_form">Exames / Procedimentos cadastrados</span></>)}
                        
                        { exames.map(item => {

                            const isEditing = exameEditando === item.id;

                            return(
                            <>
                            <div className="medical_box">
                                <div className="medical_box06m"></div>
                                <div className="medical_box06n">{examesErrors[item.id] && (<span className="medical_exames_errors">{examesErrors[item.id]}</span>)}</div>
                            </div>
                            <div className="medical_box_exames">

                                <div className="medical_box06d">
                                    <img src={expand_yes} className={`medical_exames_arrow ${examesOpen.includes(item.id) ? "open" : ""}`} onClick={() => toggleExame(item.id)}></img>
                                    <span className={`medical_exames_options ${examesOpen.includes(item.id) ? "open" : ""}`}>{examesOpen.includes(item.id) ? "FECHAR" : "ALTERAR"}</span>
                                </div>

                                <div className="medical_box06o">
                                    <div className="medical_box06e">
                                        <label for="inp" className="inp">
                                        <input type="text" placeholder="&nbsp;" disabled={!isEditing} value={isEditing ? exameDraft.exame : item.exame} onChange={e => { if (!isEditing) return; setExamesErrors(prev => { if (!prev[item.id]) return prev; const copy = { ...prev }; delete copy[item.id]; return copy; }); setExameDraft(prev => ({...prev, exame: e.target.value}));;}} onClick={() => { if (!isEditing) return; setExamesErrors(prev => { if (!prev[item.id]) return prev; const copy = { ...prev }; delete copy[item.id]; return copy; });}}></input>
                                        <span className="label">Nome do exame / procedimento</span>
                                        <span className="focus-bg"></span>
                                        </label>
                                    </div>

                                    <div className="medical_box06f"></div>

                                    <div className="medical_box06g">
                                        <label for="inp" className="inp">
                                        <input type="text" placeholder="&nbsp;" disabled={!isEditing} value={isEditing ? exameDraft.valor : Number(item.valor).toFixed(2)} onClick={() => { if (!isEditing) return; setExamesErrors(prev => { if (!prev[item.id]) return prev; const copy = { ...prev }; delete copy[item.id]; return copy; });}} onChange={e => { if (!isEditing) return; setExamesErrors(prev => { if (!prev[item.id]) return prev; const copy = { ...prev }; delete copy[item.id]; return copy; }); setExameDraft(prev => ({...prev, valor: e.target.value})); }}></input>
                                        <span className="label">Valor (R$)</span>
                                        <span className="focus-bg"></span>
                                        </label>
                                    </div>
                                </div>

                            </div>

                            <div className="medical_box_exames">
                                <div className="medical_box06j"><div className="medical_exames_expandline" style={{height: examesOpen.includes(item.id) ? "100%" : "0%"}}></div></div>
                                <div className="medical_box06l"></div>
                            </div>

                            <div className={`medical_exames_expand ${examesOpen.includes(item.id) ? "open" : ""}`}>
                                <div className="medical_box_exames">
                                    <div className="medical_box06h"><div className="medical_exames_expandline" style={{height: "100%"}}></div></div>
                                    <div className="medical_box06i">
                                        <label for="inp2" className="inp2">
                                        <textarea placeholder="&nbsp;" disabled={!isEditing} value={isEditing ? exameDraft.descricao : item.descricao} onChange={e => isEditing && setExameDraft(prev => ({...prev, descricao: e.target.value}))}></textarea>
                                        <span class="label2">Observações do exame / procedimento</span>
                                        <span class="focus-bg2"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="medical_box_exames">
                                    <div className="medical_box06j"><div className="medical_exames_expandline" style={{height: "100%"}}></div></div>
                                    <div className="medical_box06l"></div>
                                </div>
                                
                                <div className="medical_box_exames">
                                    <div className="medical_box07d"><div className="medical_exames_expandline" style={{height: "60%"}}></div></div>
                                    <div className="medical_box07e">
                                        <button type="button" name="bt3c" className="buttonsearch_form" onClick={() => isEditing ? cancelEditExame() : remove_exame(item.id)}>{isEditing ? "CANCELAR" : "REMOVER"}</button>
                                    </div>
                                    <div className="medical_box07f"></div>
                                    <div className="medical_box07g">
                                        <button type="button" name="bt3c" className="buttonsearch_form" onClick={() => isEditing ? confirmEditExame(item.id) : startEditExame(item.id)}>{isEditing ? "CONFIRMAR" : "ALTERAR"}</button>
                                    </div>
                                </div>

                                <span className="space_form"></span>
                                <span className="medical_exames_line"></span>
                                <span className="space_form"></span>
                            </div>

                            </>);
                        })}

                        <span className="title_form">Cadastro de Exames ou Procedimentos</span>

                        <span className="subtitle_form">Você pode cadastrar exames ou procedimentos, caso queira.</span>
                        <span className="medical_observacao">Caso não realize exames, procedimentos ou não queira cadastrar, basta avançar e pular essa etapa.</span>

                        <span className="error_form" ref={refErrorExame}></span>
                        <div className="medical_box">

                            <div className="medical_box06a">
                                <label for="inp" className="inp" ref={refLabelExame}>
                                <input type="text" placeholder="&nbsp;" maxLength={40} {...register("exame")} ref={(el) => {refExame.current = el; register("exame").ref(el);}} onClick={() => clearError(refExame, refLabelExame, refErrorExame, error, setError)} onChange={() => clearError(refExame, refLabelExame, refErrorExame, error, setError)}></input>
                                <span className="label">Nome do exame / procedimento</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                            <div className="medical_box06b"></div>

                            <div className="medical_box06c">
                                <label for="inp" className="inp" ref={refLabelValorExame}>
                                <input type="text" placeholder="&nbsp;" maxLength={10} {...register("valor_exame")} ref={(el) => {refValorExame.current = el; register("valor_exame").ref(el);}} onClick={() => clearError(refValorExame, refLabelValorExame, refErrorExame, error, setError)} onChange={() => clearError(refValorExame, refLabelValorExame, refErrorExame, error, setError)} onKeyDown={(e) => {if (!/[0-9,]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {e.preventDefault();}}}></input>
                                <span className="label">Valor (R$)</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                        </div>

                        <span className="space_form"></span>
                        
                        <label for="inp2" className="inp2">
                        <textarea placeholder="&nbsp;" {...register("descricao_exame")} maxLength={200} ref={(el) => {refDescription.current = el; register("descricao_exame").ref(el);}} onClick={() => clearError(refDescription, refLabelDescription, refErrorDescription, error, setError)} onChange={() => clearError(refDescription, refLabelDescription, refErrorDescription, error, setError)}></textarea>
                        <span class="label2">Observações e recomendações do exame / procedimento</span>
                        <span class="focus-bg2"></span>
                        </label>
                        
                        <span className="space_form"></span>

                        <div className="medical_box">
                            <div className="medical_box07a"></div>
                            <div className="medical_box07b"></div>
                            <div className="medical_box07c">
                                <button type="button" name="bt3c" className="buttonsearch_form" onClick={add_exame}>ADICIONAR</button>
                            </div>
                        </div>

                        <span className="space_form"></span>
                        <span className="space_form"></span>

                        <div className="medical_buttons_box">
                            <div className="medical_box08a">
                                <button type="button" name="bt3a" className="button2_form" onClick={(e) => back_step(1)}>VOLTAR</button>
                            </div>
                            <div className="medical_box08b"></div>
                            <div className="medical_box08c">
                                <button type="button" name="bt3b" className="button_form" onClick={medical_step3}>AVANÇAR</button>
                            </div>
                        </div>
                
                    </form>
                </div>
                </>
                )}


                { step === 3 &&
                (
                <>
                <div className="ft_topico">Configurar agente</div>
                <div className="ft_descricao">Chegou a hora de configurar seu agente, essa é uma etapa muito importante, aqui você definirá todas as regras para que seu agente possa dar o melhor atendimento a seus clientes.</div>
                <div className="space"></div>

                <div className="border_form medical_border_form">
                    <form className="form" onSubmit={handleSubmit(configure_agent)}>

                        <span className="step_form">
                            <span className="step_form_number">Passo 4/4</span>
                            <span className="step_form_description">&nbsp;. Agenda</span>
                        </span>

                        <span className="space_form"></span>

                        <span className="title_form">Tempo padrão de atendimento</span>
                        <span className="subtitle_form">Defina quanto tempo leva seu atendimento, através desse tempo, iremos estruturar a sua agenda com essa configuração.</span>
                        <span className="medical_observacao">Intervalo permitido = 30 minutos a 3 horas.</span>

                        <span className="error_form" ref={refErrorTempoAtendimento}></span>
                        <div className="medical_box">
                            <div className="medical_box10a">                                
                                <label for="inp" className="inp" ref={refLabelTempoAtendimento}>
                                <input type="text" placeholder="&nbsp;" maxLength={3} {...register("tempo_atendimento")} ref={(el) => {refTempoAtendimento.current = el; register("tempo_atendimento").ref(el);}} onClick={() => clearError(refTempoAtendimento, refLabelTempoAtendimento, refErrorTempoAtendimento, error, setError)} onChange={() => clearError(refTempoAtendimento, refLabelTempoAtendimento, refErrorTempoAtendimento, error, setError)} onKeyDown={(e) => {if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {e.preventDefault();}}} disabled={inputTempoAtendimento}></input>
                                <span className="label">Tempo (em minutos)</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="medical_box10b"></div>
                            <div className="medical_box10c">
                                <button type="button" name="bt4a" className="button2_form" onClick={ create_calendar } disabled={buttonTempoAtendimento}>CRIAR AGENDA</button>
                            </div>
                        </div>
                        <span className="space_form"></span>
                        
                        {showCalendar && (<MedicalCalendar refCalendario={refCalendario} calendario={calendario} />)}

                        <span className="space_form"></span>
                        <span className="space_form"></span>
                        
                        { basic?.agent?.status !== 4 && (
                        <>
                        <span className="title_form">Termos de uso</span>
                        <span className="subtitle_form">Para finalizar seu agente, leia nossos termos de uso e a nossa política de privacidade de dados.</span>
                        <span ref={refErrorTerms} className="error_form"></span>
                        <div className="medical_terms">
                            <input type="checkbox" className="checkbox_default" ref={refCheckBox} onClick={accept_terms}></input>
                            <a href="/terms" className="medical_terms_text" target="_blank" rel="noopener noreferrer">Estou ciente conforme os termos de uso.</a>
                        </div>
                        </>
                        )}

                        <span className="space_form"></span>
                        <span ref={refError} className="error_form"></span>
                        <span className="space_form"></span>
                        <div className="medical_buttons_box">
                            <div className="medical_box08a">
                                <button type="button" name="bt4c" className="button2_form" onClick={ (e) => back_step(2) } disabled={isPending}>VOLTAR</button>
                            </div>
                            <div className="medical_box08b"></div>
                            <div className="medical_box08c">
                                <button type="submit" ref={refButtonConcluir} name="bt4d" className="button_form" disabled={isPending}>{basic?.agent?.status === 4 ? "ALTERAR" : "CONCLUIR"}</button>
                            </div>
                        </div>

                    </form>
                </div>
                </>
                )}

                { step === 4 && (

                    indisponivel ? (
                    <>
                    <div className="ft_topico">Agente configurado</div>
                    <div className="ft_descricao">Seu agente foi configurado com sucesso</div>
                    <div className="space"></div>
                    <img className="medical_image" src={icon_success}></img>
                    <div className="space"></div>
                    <span className="medical_success_04"></span>
                    <span className="space_form"></span>
                    <span className="medical_success_03" style={{width: "70%", textAlign: "center"}}>{firstName(basic.client.responsavel) + ", todas as informações foram armazenadas e muito em breve iremos ativar seu agente."}</span>
                    <div className="space"></div>
                    <span className="medical_success_01">Assim que o agente for ativado, enviaremos um email lhe avisando</span>
                    </>
                    ) : (
                    <>
                    <div className="ft_topico">{ basic.agent.status === 4 ? "Agente alterado" : "Agente configurado" }</div>
                    <div className="ft_descricao">{ basic.agent.status === 4 ? "Você alterou seu agente e ele está pronto para ser testado com as novas informações." : "Parabéns " + firstName(basic.client.responsavel) +  ", você concluiu todas as etapas e seu agente está pronto para ser testado." }</div>
                    <div className="space"></div>
                    <img className="medical_image" src={icon_success}></img>
                    <div className="space"></div>
                    <span className="medical_success_01">O nome do seu agente é:</span>
                    <span className="medical_success_04">{basic.agent.nome}</span>
                    <div className="space"></div>
                    <span className="medical_success_01">Ele foi configurado na linha telefonica:</span>
                    <span className="medical_success_04">{telefone}</span>
                    <div className="space"></div>
                    <span className="medical_success_03">Para testar e interagir com seu agente, basta dar um "oi" no WhatsApp para o número de telefone em que ele foi configurado.</span>
                    <span className="space_form"></span>
                    
                    { basic.agent.status !== 4 && (<><span className="medical_success_02">Aproveite!<br />Você tem 7 dias gratuítos para testar seu agente</span></>) }
                    
                    <div className="space"></div>
                    <span className="medical_success_05">Você poderá realizar agendamentos de testes e vizualizá-los em Painel do Cliente &rarr; Agenda.</span>
                    </>
                ))}

                <div className="space"></div>
                <div className="space"></div>
                <div className="button_back_form"><button type="button" name="btbck" className="button2_form" onClick={() => navigate("/panel")}>VOLTAR</button></div>
                <div className="space"></div>
                <div className="space"></div>
         
            </div>
        
        <Footer access={1}></Footer>
        
        </div>
    )
}